import LOGO from "../images/MeanMachine.png";

export const Team__MeanMachine = {
  name: "Mean Machine",
  logoImage: LOGO,
  teamImage: null,
  teamLogoColor: "#b01e23",
  teamJerseyColor: "#0E293D",

  // Stats
  gamesWon: 1,
  gamesLost: 2,
  gamesTied: 0,
  gamesTiedWon: 0,

  ownGoalsInFavor: 0,
  goalsScoredAgainst: 56 + 41 + 0,
  defaultGoals: 0,

  isChampion: false,
  isEliminated: false,

  players: [
    {
      goalsScored: 52 + 36 + 2,
    },
  ],
};
